import * as React from 'react';
import Icons from '../icons';

export default class EmptyCombinedView extends React.Component {
    constructor(props){
        super(props);
    }

    render(){
        return(
            <div className="emptyScreen">
                <Icons name="EmptyCombinedView" className="" />
                <h2>No data found</h2>
                <label>There is no data available for the applied filters.</label>
            </div>
        );
    }
}